import { isDevelopmentMode, methods, sendRequest } from "../base";

export const getUserToken = () => {
  return sendRequest(isDevelopmentMode() ? "/accounts/login" : "/users/token/");
};
export const logoutUser = () => {
  return sendRequest(
    isDevelopmentMode() ? "/accounts/logout" : "",
    methods.POST,
    {}
  );
};
export const getUserRefreshToken = () => {
  const refresh = window.localStorage.getItem("refresh");
  return sendRequest(
    isDevelopmentMode() ? "/accounts/refresh-token" : "/users/refresh-token/",
    methods.POST,
    { refresh: refresh }
  );
};
export const getUserValidationResult = () => {
  return sendRequest(
    isDevelopmentMode()
      ? "/accounts/validation-result"
      : "/users/refresh-token/"
  );
};

export const sendUserPhoneOrEmail = (formData, is_registered) => {
  return sendRequest(
    isDevelopmentMode()
      ? is_registered
        ? "/accounts/login"
        : "/accounts/register"
      : "/users/send-token/",
    methods.POST,
    formData
  );
};

export const checkOtpCode = (formData) => {
  return sendRequest(
    isDevelopmentMode() ? "/accounts/verify-otp" : "/users/verify/",
    methods.POST,
    formData
  );
};

export const sendIsUserRegistered = (formData) => {
  return sendRequest(
    isDevelopmentMode()
      ? "/accounts/check-registered"
      : "/users/is-registered/",
    methods.POST,
    formData
  );
};
